import { render, staticRenderFns } from "./TimelinePoll.vue?vue&type=template&id=fc37a640&scoped=true"
import script from "./TimelinePoll.vue?vue&type=script&lang=js"
export * from "./TimelinePoll.vue?vue&type=script&lang=js"
import style0 from "./TimelinePoll.vue?vue&type=style&index=0&id=fc37a640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc37a640",
  null
  
)

export default component.exports